import React, { Component, Fragment } from "react";
import { func, string } from "prop-types";
import Button from "pages/_components/Button";
import FieldLabel from "pages/_components/fields/FieldLabel";
import TextField from "pages/_components/fields/TextField";
import classNames from "classnames";
import { isMobileNative } from "util/device";
import { Box } from "@ui-kit/components/index.es";

const SET_PRODUCT_ALIAS_MOCK_FORM = {
    errors: {},
    touched: {},
    setErrors: () => {},
};
class InputSetProductAlias extends Component {
    static propTypes = {
        onSave: func.isRequired,
        defaultValue: string.isRequired,
    };

    state = {
        value: null,
        inputFocus: false,
    };

    handleOnChange = (event) => {
        this.setState({ value: event.target.value });
    };

    handleSave = () => {
        const { value } = this.state;
        const { onSave } = this.props;

        if (onSave) {
            onSave(value);
        }
    };

    handleFocusBlur = () => {
        const { inputFocus } = this.state;

        this.setState({ inputFocus: !inputFocus });
    };

    render() {
        const { value, inputFocus } = this.state;
        const { defaultValue } = this.props;
        const fieldValue = value !== null ? value : defaultValue;
        const field = {
            name: "modifyAlias",
            value: fieldValue,
            onChange: this.handleOnChange,
            onBlur: () => {},
        };

        return (
            <Fragment>
                <FieldLabel key="1" labelKey="products.alias.edit.label.mobile" idField={defaultValue} />
                <div className="w-100" onFocus={this.handleFocusBlur} onBlur={this.handleFocusBlur}>
                    <TextField
                        field={field}
                        form={SET_PRODUCT_ALIAS_MOCK_FORM}
                        hideLabel
                        hidePlaceholder
                        idForm=""
                        labelText="products.alias.edit.label.mobile"
                        idField="modifyAlias"
                        className="w-100"
                        elementClassName="height-40"
                        maxLength={50}
                        // eslint-disable-next-line jsx-a11y/no-autofocus
                        autoFocus
                    />
                </div>
                <Box
                    className={classNames(`p-fixed bottom-0 left-0 w-100 px-3 padding-bottom-safe-area`, {
                        "ios-avoid-keyboard-margin": inputFocus && isMobileNative,
                        "mb-3": (!inputFocus && isMobileNative) || !isMobileNative,
                    })}
                    css={{ bottom: !inputFocus ? 64 : 0 }}>
                    <Button
                        key="10"
                        label="global.send"
                        bsStyle="primary"
                        type="submit"
                        className="w-100"
                        onClick={this.handleSave}
                    />
                </Box>
            </Fragment>
        );
    }
}

export default InputSetProductAlias;
